import { Card } from "@/shared/components/Card";
import { useState } from "react";
import styles from "./powerBillCard.module.css";
import { usePowerbill } from "../viewModal/powerBillViewmodal";
import { useLocation } from "react-router-dom";
import { Button } from "@/components/ui/Button";
import { Dropdown, DropdownTrigger, DropdownContent, DropdownItem } from "@/components/ui/Dropdown";
import { CheckboxItem } from "@/components/ui";
import { Modal } from "@/shared/modal";
import { LeafIcon } from "@/assets/svg/LeafIcon";
import { ExternalLinkIcon } from "@/assets/svg/ExternalLinkIcon";
import { ElectricBoltIcon } from "@/assets/svg/ElectricBoltIcon";
import { ChevronDownIcon } from "@/assets/svg/ChevronDownIcon";

export const PowerCardPlans = () => {
  const [isTermsOpen, setIsTermsOpen] = useState(false);

  const { selectedProperty } = useLocation().state;
  const { plans, suppliers, setUtilityName, term, setTerm, utilityName, enrollInPlanCallback } =
    usePowerbill(selectedProperty);
  console.log("selectedProperty", selectedProperty);

  const options = [12, 24, 36];

  const toggle = (value: number) => {
    setTerm((prev: number[]) =>
      prev.includes(value) ? prev.filter((v: number) => v !== value) : [...prev, value]
    );
  };

  return (
    <Card className={styles.powerCardPlans}>
      <div className={styles.headerContainer}>
        <div className={styles.powerCardPlansTitle}>Power Card Plans</div>

        <div className={styles.filterContainer}>
          <Dropdown>
            <DropdownTrigger>
              <Button className={styles.supplierBtn}>
                {utilityName || "Select Supplier"}
                <ChevronDownIcon width={16} height={16} />
              </Button>
            </DropdownTrigger>

            <DropdownContent>
              {suppliers.map((supplier) => (
                <DropdownItem key={supplier} onClick={() => setUtilityName(supplier)}>
                  {supplier}
                </DropdownItem>
              ))}
            </DropdownContent>
          </Dropdown>

          <div className={styles.termFilter}>
            {options.map((opt) => (
              <CheckboxItem
                key={opt}
                checked={term.includes(opt)}
                onChange={() => toggle(opt)}
                label={`${opt}`}
              />
            ))}
          </div>
        </div>
      </div>
      {/* {options.map((opt) => (
    <Checkbox key={opt} checked={term.includes(opt)} onChange={() => setTerm([...term, opt])} label={opt} />
))} */}
      {/* <div className={styles.powerCardPlansTitle}>Power Card Plans</div> */}
      {plans?.length === 0 ? (
        <div className={styles.noData}>No power plans available for selected filters</div>
      ) : (
        <>
          {plans.map((plan) => (
            <Card key={plan.id} className={styles.planCard}>
              <div className={styles.planHeader}>
                <div className={styles.planLeft}>
                  <div className={styles.planIcon}>
                    <ElectricBoltIcon width={22} height={22} />
                  </div>

                  <div className={styles.planContent}>
                    <div className={styles.planTitle}>{plan.title}</div>

                    <div className={styles.planSub}>
                      {plan.description} • {plan.price}$ •
                      <LeafIcon className={styles.leafIcon} />
                      {plan.renewablePercentage ?? 0}%
                    </div>

                    <div className={styles.planSupplier}>{plan.supplier?.name}</div>

                    <div className={styles.planSupplierId}>Supplier ID : {plan.supplier?.id}</div>
                  </div>
                </div>

                <div className={styles.planButtons}>
                  <Button className={styles.termsBtn} onClick={() => setIsTermsOpen(true)}>
                    Terms & Conditions
                  </Button>

                  <Button
                    className={styles.viewBtn}
                    // onClick={() =>
                    //   navigate(routes.energyBotScreen, {
                    //     state: {
                    //       headlessEnrollmentUrl: plan.headlessEnrollmentUrl,
                    //     },
                    //   })
                    // }
                  >
                    Details
                  </Button>

                  <Button
                    className={styles.enrollBtn}
                    onClick={() => enrollInPlanCallback(plan.id)}
                  >
                    Enroll
                    <ExternalLinkIcon />
                  </Button>
                </div>
              </div>
            </Card>
          ))}
        </>
      )}

      <Modal isOpen={isTermsOpen} onClose={() => setIsTermsOpen(false)} title="Terms & Conditions">
        <div className={styles.termsContent}>
          <p>These are the terms and conditions for this energy plan.</p>

          <p>Please review the details carefully before enrolling.</p>
        </div>
      </Modal>
    </Card>
  );
};
